import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Text} from "@mantine/core";
import {RatePlan} from "../types.ts";

export const useTableColumns = (
    {onRecordClick}: { onRecordClick: (record: RatePlan) => void },
) => {

    const columns: DataTableColumn<RatePlan>[] = [
        {
            accessor: 'name',
            title: I18n.get('Rate Plan'),
            render: (record: RatePlan) => (
                <Text
                    c="blue"
                    style={{cursor: 'pointer'}}
                    onClick={() => onRecordClick(record)}
                >
                    {record.name}
                </Text>
            ),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
        },
    ];

    return {
        columns,
    };
};
